import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const shouldShowAmount = amount => amount && parseFloat(amount) > 0;

const TaxesAndFeesHelpText = ({
  tax,
  serviceFee,
  customFee,
  customFeeName,
  bundleServiceFeeWithCustomFee,
  bundledServiceAndCustomFees
}) => {
  const customFeeAmount = bundleServiceFeeWithCustomFee
    ? bundledServiceAndCustomFees
    : customFee;

  return (
    <React.Fragment>
      {shouldShowAmount(tax) && (
        <Typography variant="subtitle1" data-testid="tooltip-tax">
          Tax: ${tax}
        </Typography>
      )}
      {!bundleServiceFeeWithCustomFee && shouldShowAmount(serviceFee) && (
        <Typography variant="subtitle1" data-testid="tooltip-service-fee">
          Service Fee: ${serviceFee}
        </Typography>
      )}
      {shouldShowAmount(customFeeAmount) > 0 && (
        <Typography variant="subtitle1" data-testid="tooltip-custom-fee">
          {customFeeName}: ${customFeeAmount}
        </Typography>
      )}
    </React.Fragment>
  );
};

TaxesAndFeesHelpText.propTypes = {
  tax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  serviceFee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  customFee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  customFeeName: PropTypes.string,
  bundleServiceFeeWithCustomFee: PropTypes.bool,
  bundledServiceAndCustomFees: PropTypes.string
};
export default TaxesAndFeesHelpText;
